import React, { useState } from 'react';
import { useLMS } from '../../context/LMSContext';
import ReflectionManager from './ReflectionManager';

/**
 * AdminReflections – Standalone page for admins/professors to manage weekly
 * reflections end to end: write the questions for each week, read the student
 * responses, and download them as PDFs. Provides cohort filtering, then renders
 * ReflectionManager for the selected cohort.
 *
 * Questions are shared across cohorts (they hang off the week), but responses
 * and every export on this page are scoped to the selected cohort.
 */
const AdminReflections = () => {
  const { cohorts, selectedCohortId, setSelectedCohortId } = useLMS();
  const [localCohortId, setLocalCohortId] = useState(selectedCohortId || '');

  const handleCohortChange = (e) => {
    const id = e.target.value || null;
    setLocalCohortId(id);
    setSelectedCohortId(id);
  };

  return (
    <div className="admin-reflections-page">
      <div className="page-header">
        <div>
          <h1>Weekly Reflections</h1>
          <p>Write reflection questions, review responses, and download PDFs</p>
        </div>
      </div>

      {/* Cohort Selector */}
      <div className="cohort-selector-card">
        <label>Select Cohort:</label>
        <select
          value={localCohortId || ''}
          onChange={handleCohortChange}
        >
          <option value="">Choose a cohort...</option>
          {cohorts.map(cohort => (
            <option key={cohort.id} value={cohort.id}>
              {cohort.name} ({cohort.status})
            </option>
          ))}
        </select>
      </div>

      {!localCohortId && (
        <div className="empty-state">
          <div className="empty-icon">💭</div>
          <h3>Select a Cohort</h3>
          <p>Choose a cohort above to view student reflections</p>
        </div>
      )}

      {localCohortId && (
        <div style={{ backgroundColor: 'var(--card-bg, #fff)', borderRadius: '12px', padding: '20px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
          <ReflectionManager cohortId={localCohortId} />
        </div>
      )}
    </div>
  );
};

export default AdminReflections;
